module.exports = __webpack_public_path__ + "img/badge-list-thumb-133.26ae125d.png";